"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = hexColorToRGB;

require("core-js/modules/es6.regexp.replace");

var _isHexColorValue = _interopRequireDefault(require("../is-hex-color-value"));

var START_R_SEGMENT = 0;
var END_R_SEGMENT = 2;
var START_G_SEGMENT = 2;
var END_G_SEGMENT = 4;
var START_B_SEGMENT = 4;
var END_B_SEGMENT = 6;
var HEXADECIMAL = 16;
/**
 * Static method that takes a color removes the '#' sign and creates RGB segments
 * @param {String} color - The color
 * @returns {object} {red: number, green: number, blue: number} - object with RGB segments
 */

function hexColorToRGB(color) {
  if (!(0, _isHexColorValue.default)(color)) {
    throw new TypeError("color must be a valid hex color. Provided value: ".concat(JSON.stringify(color)));
  }

  var colorWithoutPawn = color.replace('#', '');
  return {
    red: Math.ceil(parseInt(colorWithoutPawn.substring(START_R_SEGMENT, END_R_SEGMENT), HEXADECIMAL)),
    green: Math.ceil(parseInt(colorWithoutPawn.substring(START_G_SEGMENT, END_G_SEGMENT), HEXADECIMAL)),
    blue: Math.ceil(parseInt(colorWithoutPawn.substring(START_B_SEGMENT, END_B_SEGMENT), HEXADECIMAL))
  };
}